module.exports = __webpack_public_path__ + "91b715efacb88c6b1db1bc5e76855c57.svg";